/* eslint-disable @stylistic/max-len */

'use client';

import Script from 'next/script';

import type { Component } from './types';

export const OguryScript: Component = () => (
  <>
    <Script
      id="ogury-script"
      type="text/javascript">
      {`window.top.OG_ad_units = window.top.OG_ad_units || [];
       window.top.OG_ad_units.push({
           ad_unit_id: '304165_default',
           asset_key: 'OGY-6E906F7D6B4D',
           click_url: '%%CLICK_URL_UNESC%%',
           params:{
               max_width: 180,
               max_height: 180,
               y_margin: 25
           },
           passback: {
               ad_unit_id: 'wm-tg-thmb-sgcarm-sgcmp-tj9t6040y3lt'
           }
       });`}
    </Script>
    <Script
      src="https://mwtw.presage.io/v1/tag.js"
      type="text/javascript" />
  </>
);
